

    require('./toolbox/ToolboxModel');
    require('./toolbox/ToolboxView');

    require('./toolbox/feature/SaveAsImage');
    require('./toolbox/feature/MagicType');
    require('./toolbox/feature/DataView');
    require('./toolbox/feature/DataZoom');
    require('./toolbox/feature/Restore');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/toolbox.js
// module id = YsUA
// module chunks = 5